import { useQuery, UseQueryOptions } from "react-query";
import { getResources } from "../services/resources.service";
import { IRequest } from "../interfaces/authentication.interface";
import { IVimeo } from "../interfaces/vimeo.interface";
import { getVideo } from "../services/vimeo.service";

export function useVimeo<T extends any = IRequest<IVimeo>>(
    videoId?: string,
    options?: UseQueryOptions<any, unknown, T>
) {
    return useQuery({
        queryKey: ["vimeo", videoId],
        queryFn: () => getVideo(videoId),
        retry: 1,
        refetchOnWindowFocus: false,
        staleTime: 15 * 60 * 1000,
        ...options
    });
}
